module.exports = __webpack_public_path__ + "img/empty.46ab59d5.png";